import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getToken } from '../../../../reducers/linkedin/duck';
import LinkedinLoginButton from './LinkedinLoginButton';


const mapStateToProps = ({
  linkedinStore: {
    status, accessToken,
  },
  registrationStore: {
    status: registrationStatus,
  },
}) => ({
  status,
  registrationStatus,
  accessToken,
});

const mapDispatchToProps = {
  getToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LinkedinLoginButton));



// WEBPACK FOOTER //
// ./src/containers/SocialLoginWrapper/components/LinkedinLoginButton/index.js